import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import i18n from '../i18n/config';

interface FormSuccessProps {
  onClose: () => void;
}

const FormSuccess: React.FC<FormSuccessProps> = ({ onClose }) => {
  return (
    <div className="text-center py-8">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
        <CheckCircle className="h-8 w-8 text-green-600" />
      </div>
      
      <h3 className="text-xl font-medium text-gray-900 mb-3">
        {i18n.t('form.messages.success')}
      </h3>
      
      <p className="text-base text-gray-600 mb-6 max-w-md mx-auto">
        {i18n.t('form.messages.success_subtitle')}
      </p>

      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            {i18n.t('form.submit')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </button>
          
          <a
            href="/contact"
            className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            {i18n.t('footer.contact.title')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default FormSuccess;